import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FilterUtils } from 'primeng/components/utils/filterutils';
import 'rxjs/operator/map';
import { CommonSerivce } from '../shared/services/common.service';
import { UserService } from '../shared/services/user.service';
import { ConfirmationService } from 'primeng/api';
import { jsPDF } from "jspdf";
//import * as jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Observable } from 'rxjs/Observable';
//import 'jspdf-autotable';
//import jsPDF from 'jspdf';
//import 'jspdf-autotable';
import 'rxjs/Rx';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import * as XLSX from "xlsx-js-style";


@Component({
  selector: 'etsProject',
  styleUrls: ['../shared/share.component.css'],
  providers: [CommonSerivce, UserService, DatePipe, ConfirmationService],
  templateUrl: './etsProject.component.html'
})



export class EtsProjectComponent implements OnInit {

  /*
      RecordList - Search result list
      SelectedRecordList - User selected record (Multiple) in the result table
      SelectedRecord - User selected record (Single) for edition
  */
  public RecordList: IProject[];
  public SelectedRecordList: IProject[];
  public SelectedRecord: IProject;

  public DocumentRecordList: IProjectDoc[];
  public SelectedDocumentRecordList: IProjectDoc[];
  public SelectedDocumentRecord: IProjectDoc;

  public LogRecordList: IProjectLog[];
  public SelectedLogRecordList: IProjectLog[];
  public SelectedLogRecord: IProjectLog;

  public GenNextNumberFieldHolder: IGenNextNumber;
  public NextNumberOutput: INextNumber;

  public InputErrorMsg: Message[] = [];

  //  Hold the value of the user inputted search field, to be used for searching
  public SearchFieldHolder: any;
  public SearchDnFieldHolder: any;
  public projectCols: any;
  public documentCols: any;
  public exportColumns: any;
  public pdfColumns = [];
  public logCols: any;


  //  Code value list for List Box, add required code value list
  public DomainList: IListValue[];
  public DataRoleList: IDataRole[];
  public ProcessRoleList: IProcessRole[];
  public ActiveFlagList: IListValue[];
  public YesNoList: IListValue[];
  public CompanyList: IListValue[];
  public AttachmentList: IAttachmentValue[];
  public CompanyListResponsed: IListValue[];
  public TenderCategoryList: IListValue[];
  public TenderPropertyList: IListValue[];
  public BusinessUnitList: IListValue[];
  public DocumentCategoryList: IListValue[];
  public DocumentTypeList: IListValue[];
  public CompanyStatus: ICompanyStatus;

  public loggedInType: string = "";
  public loggedInCompanyCode: string = "";

  public currentVertificationKey: string = "";
  public currentRegisterFlag: string = "";
  public currentInviteFlag: string = "";
  public currentTempCompany: string = "";
  public currentCompanyStatus: string = "";

  public globalFilterValue1: string = "";
  public globalFilterValue2: string = "";
  public globalFilterValue3: string = "";
  public globalFilterValue4: string = "";
  public globalFilterValue5: string = "";
  public globalFilterValue6: string = "";

  public resultMsgs: Message[] = [];

  /*
      sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
      softF - define the sorting field name
  */
  sortO: number = 0;
  sortF: string = '';


  /*
      Major control variables
          FormTitle - Initial Form Title for the landing form
          PrimaryApiPath - Path for the API controller per component 
          ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
          AutoReload - control auto reload component
          
  */
  FormTitle: String = "Work With Project";
  FormAccessRight: String = "NA";
  PrimaryApiPath: string = "api/EtsProject/";
  DocumentApiPath: string = "api/EtsProjectDoc/";
  LogApiPath: string = "api/EtsProjectLog/";
  CompanyApiPath: string = "api/BcpCompany/";
  ContactApiPath: string = "api/BcpContact/";
  ListValueApiPath: string = "api/BcpListValue/";
  AuthApiPath: string = "api/BcpJwtAuth/getDistinguishedName/";
  AttachmentApiPathLocal: string = "api/BcpAttachment/";
  AttachmentApiPathAzure: string = "api/BcpAzureAttachment/";
  AttachmentApiPath: string = " ";
  ReportApiPath: string = "api/EtsReport/";


  ShowEditForm: Boolean = false;
  ShowNotAuthorizedForm: Boolean = false;
  SuccessUpload: Boolean = false;
  AddMode: string = "N";
  checkedError: string = "";
  HideMessage: Boolean = true;

  AutoReload: Boolean = true;
  AttachmentAutoReload: Boolean = true;

  scrollHeight: string = "";
  scrollWidth: string = "";

  httpOriginalUrl: String;
  stringifyValue = "";
  stringifyUploadValue = "";
  Headers = new HttpHeaders();
  isLoggedIn: boolean = false;
  dateFormat: String = "yy-mm-dd";

  //Attachment related
  public record: any;
  uploadFile: File;

  documentLineNumber: number = 0;
  newTenderRecordId: any;
  newDocumentRecordId: any;
  inputDocumentCompany: string = "";
  inputMessageCompany: string = "";
  inputLogCompany: string = "";
  inputSendAllCompany: boolean = false;
  inputDocumentCategory: string = "";
  inputDocumentType: string = "";
  inputRemark: string = "";
  public UpdateTenderPriceFieldHolder: IUpdateTender;
  public WriteLogFieldHolder: IWriteLog;
  public UserNameDataSet: IUserName;
  public ReportFieldHolder: IReportData;
  //responseCycle: number = 0;
  public RecordCount: number = 0;
  displayTotalAmount: string = "";
  savedTotalAmount: string = "";
  enteredTotalAmount: number = 0;
  Accept1: Boolean = false;
  Accept2: Boolean = false;
  public index: number = 0;
  currentUserNameLong: string = "";

  //excel variable
  strLine: string;
  excelRow: string[] = [];
  SheetNames = [];
  Sheets = {};
  cellList: string[];
  lastRowNumber: number;
  currentProcessRow: number = -1;
  currentProcessColumn: number = -1;
  rangeFromColumn: number = -1;
  rangeFromRow: number = -1;
  rangeToColumn: number = -1;
  rangeToRow: number = -1;
  delimiter: string = "|";
  //excel variable - End

  processingFlag: string = "N";
  processingReport: string = "";
  listLength1: number = 0;

  //For display Edit and Delete Images
  //public imgEdit = require("../shared/Images/edit.gif");
  //public imgDelete = require("../shared/Images/delete.gif");

  //for animation status
  //animStatus: string = 'inactive';




  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string
    , private bcp: CommonSerivce
    , private datePipe: DatePipe
    , private confirmationService: ConfirmationService
  ) {
    //  this.httpHeaders = this.bcp.getHttpHeader();
    this.PrimaryApiPath = originUrl + this.PrimaryApiPath;
    this.DocumentApiPath = originUrl + this.DocumentApiPath;
    this.LogApiPath = originUrl + this.LogApiPath;
    this.CompanyApiPath = originUrl + this.CompanyApiPath;
    this.ContactApiPath = originUrl + this.ContactApiPath;
    this.ListValueApiPath = originUrl + this.ListValueApiPath;
    this.ReportApiPath = originUrl + this.ReportApiPath;

    this.FormAccessRight = this.bcp.getAccessRightByProcess('TENDER');
    this.isLoggedIn = this.bcp.getLoginStatus();

    this.loggedInType = this.bcp.getCurrentUserAccountType();
    this.loggedInCompanyCode = this.bcp.getCurrentCompanyCode();

    this.AttachmentApiPath = this.AttachmentApiPathLocal;
    if (this.bcp.getAttachmentTarget() == "AZURE") {
      this.AttachmentApiPath = this.AttachmentApiPathAzure;
    }


    //get all list value for drop down list
    this.getListValue();
    //this.getListValueByDomain();
    this.getDomainList();
    this.getCompanyList(this.bcp.getCurrentDomainId(), 'E');
    this.getUserNameLong(this.bcp.getCurrentDomainId(), this.bcp.getCurrentLoginUser());

    //this.getData();

    this.resetSearchField();
    this.FormTitle = "Work With Projects";
    this.ShowNotAuthorizedForm = false;
    this.ShowEditForm = false;

    this.getFirstPage();

    this.scrollHeight = this.bcp.getDataTableHeight(4);
    this.scrollWidth = this.bcp.getDataTableWidth();

    this.SelectedRecord = null;
    this.InputErrorMsg = [];

    this.projectCols = [
      { field: 'actions', header: 'Actions', width: '50', size: '10' },
      //{ field: 'expand', width: '20', size: '5' },
      //{ field: 'id', header: 'Id', width: '10', size: '10' },
      { field: 'domainId', header: 'Domain', width: '60', size: '10' },
      { field: 'projectId', header: 'Project ID', width: '60', size: '10' },
      { field: 'tenderCategory', header: 'Category', width: '60', size: '10' },
      { field: 'tenderProperty', header: 'Property', width: '50', size: '10' },
      { field: 'subject', header: 'Subject', width: '140', size: '10' },
      { field: 'tenderStatus', header: 'Status', width: '50', size: '10' },
      { field: 'tenderDate02', header: 'Open Date', width: '60', size: '10' },
      { field: 'tenderDate03', header: 'Due Date', width: '60', size: '10' },
      { field: 'companyCode', header: 'Award Company Code', width: '80', size: '10' },
    ];


    this.documentCols = [
      { field: 'actions', header: 'Actions', width: '30', size: '10' },
      //{ field: 'lineId', header: 'Line No', width: '30', size: '10' },
      { field: 'projectDocumentCategoryDesc', header: 'Category', width: '70', size: '10' },
      { field: 'projectDocumentTypeDesc', header: 'Document Type', width: '70', size: '10' },
      { field: 'remark', header: 'Remark', width: '150', size: '10' },
      { field: 'displayName', header: 'File Name', width: '100', size: '10' },
      //{ field: 'companyCode', header: 'Company Code', width: '50', size: '10' },
      //{ field: 'attachmentRecordId', header: 'A ID', width: '50', size: '10' },
      //{ field: 'id', header: 'Id', width: '20', size: '10' },
    ];


    this.logCols = [
      { field: 'createDate', header: 'Action Date & Time', width: '10', size: '10' },
      { field: 'description', header: 'Description', width: '100', size: '10' },
    ];

 

  }

  ngOnInit() {

    //console.log("on init");

    FilterUtils['custom'] = (value, filter): boolean => {
      if (filter === undefined || filter === null || filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      return parseInt(filter) > value;
    };

  }


  //-----------------------------------------------------------------------------
  //                            Fetch/ Search Data
  //-----------------------------------------------------------------------------

  //to get required code list from Web API
  getListValue() {
    //get list value  Box
    //this.http.get(this.PrimaryApiPath + "GetProcessRole", this.bcp.getHttpOptions())
    //  .subscribe((result: any[]) => {
    //    this.DataRoleList = result;
    //  });

    //this.http.get(this.PrimaryApiPath + "GetProcessRole", this.bcp.getHttpOptions())
    //  .subscribe((result: any[]) => {
    //    this.ProcessRoleList = result;
    //  });

    this.http.get(this.ListValueApiPath + "ByListCode2/" + "BCP" + "/ACTIVE_FLAG", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.ActiveFlagList = result;
      });

    //build yes/no list
    this.YesNoList = [{ label: "Y - [Yes]", value: "Y" }, { label: "N - [No]", value: "N" }];

  }


  //to get required code list from Web API
  async getListValueByDomain() {
    const promises = [];
    //get list value  Box
    this.http.get(this.ListValueApiPath + "ByListCode4/" + this.SelectedRecord.domainId + "/PJ_DOC_CAT", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.TenderCategoryList = result;
      });

    this.http.get(this.ListValueApiPath + "ByListCode2/" + this.SelectedRecord.domainId + "/TD_PPTY", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.TenderPropertyList = result;
      });

    this.http.get(this.ListValueApiPath + "ByListCode2/" + this.SelectedRecord.domainId + "/BU", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.BusinessUnitList = result;
      });

    //this.http.get(this.ListValueApiPath + "ByListCode3/" + this.SelectedRecord.domainId + "/PJ_DOC_CAT", this.bcp.getHttpOptions())
    //  .subscribe((result: any[]) => {
    //    this.DocumentCategoryList = result;
    //  });

    this.DocumentCategoryList = await this.http.get(this.ListValueApiPath + "ByListCode3/" + this.SelectedRecord.domainId + "/PJ_DOC_CAT", this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();

    //this.http.get(this.ListValueApiPath + "ByListCode3/" + this.SelectedRecord.domainId + "/PJ_DOC_TYPE", this.bcp.getHttpOptions())
    //  .subscribe((result: any[]) => {
    //    this.DocumentTypeList = result;
    //  });

    this.DocumentTypeList = await this.http.get(this.ListValueApiPath + "ByListCode3/" + this.SelectedRecord.domainId + "/PJ_DOC_TYPE", this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();

  }


  getDomainList() {
    this.http.get("api/BcpDomain/DomainList", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DomainList = result;
      });
  }


  getCompanyList(selectedDomain, selectedCompanyType) {
    this.http.get(this.CompanyApiPath + "GetCompanyListByType/" + selectedDomain + "/" + selectedCompanyType, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CompanyList = result;

      });
  }


  getLabel(list: IListValue[], inputvalue: string): any {
    //console.log('Get label for input value of ' + inputvalue);
    if (list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].value == inputvalue) {
          return list[i].label;
        }
      }
    }
  }

  //get user name data
  getUserNameLong(domainId: string, contactId: string) {
    this.currentUserNameLong = "";
    this.UserNameDataSet = null;
    this.UserNameDataSet = JSON.parse('{"id": 0}');
    this.http.get(this.ContactApiPath + "GetUserFullName/" + domainId + "/" + contactId, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.UserNameDataSet = result;
        this.currentUserNameLong = this.UserNameDataSet.userNameLong;
      });
  }


  //determine what the first page should be shown
  async getFirstPage() {
    if (this.loggedInType != 'E') {
      this.getData();
    }
    else {
      await this.getCompanyStatus(this.bcp.getCurrentDomainId(), this.loggedInCompanyCode);
      if (this.currentCompanyStatus == "ACTIVE" || this.currentTempCompany == 'Y') {
        this.getData();
      } else {
        this.ShowNotAuthorizedForm = true;
      }
    };
  }


  //get company status fields
  async getCompanyStatus(domainId, companyCode) {
    this.CompanyStatus = await this.http.get(this.CompanyApiPath + "GetCompanyStatus/" + domainId + "/" + companyCode, this.bcp.getHttpOptions())
      .map((response: any) => response).toPromise();
    this.currentVertificationKey = this.CompanyStatus.vertificationKey;
    this.currentRegisterFlag = this.CompanyStatus.registerFlag;
    this.currentInviteFlag = this.CompanyStatus.inviteFlag;
    this.currentTempCompany = this.CompanyStatus.tempCompany;
    this.currentCompanyStatus = this.CompanyStatus.companyStatus;
  }


  getData() {
    this.AutoReload = true;
    if (this.loggedInType == 'D') {
      this.http.get(this.PrimaryApiPath + "GetByDomain/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentDataRole(), this.bcp.getHttpOptions())
        .subscribe((result: any) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    } else if (this.loggedInType == 'B') {
      this.http.get(this.PrimaryApiPath, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = new Date(this.RecordList[i].tenderDate02).toISOString().slice(0, 10);
              }
              if (this.RecordList[i].tenderDate04 != null) {
                this.RecordList[i].tenderDate03 = new Date(this.RecordList[i].tenderDate03).toISOString().slice(0, 10);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    } else {
      this.http.get(this.PrimaryApiPath + "GetByDomainCompany/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentDataRole() + "/" + this.loggedInCompanyCode, this.bcp.getHttpOptions())
        .subscribe((result: any) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    };

  }


  //get record by id and assign to selected record
  getDataById(id) {
    this.http.get(this.PrimaryApiPath + id, this.bcp.getHttpOptions())
      .subscribe(async (data: any) => {
        this.SelectedRecord = data;
        this.SelectedRecord.successAward = this.bcp.convertYesNoToBoolean(this.SelectedRecord.successAward);
        //this.refreshExpressInterestText();;
        if (this.SelectedRecord.tenderDate01) {
          this.SelectedRecord.tenderDate01 = new Date(this.SelectedRecord.tenderDate01);
        }
        if (this.SelectedRecord.tenderDate02) {
          this.SelectedRecord.tenderDate02 = new Date(this.SelectedRecord.tenderDate02);
        }
        if (this.SelectedRecord.tenderDate03) {
          this.SelectedRecord.tenderDate03 = new Date(this.SelectedRecord.tenderDate03);
        }
        if (this.SelectedRecord.tenderDate04) {
          this.SelectedRecord.tenderDate04 = new Date(this.SelectedRecord.tenderDate04);
        }
        if (this.SelectedRecord.tenderDate05) {
          this.SelectedRecord.tenderDate05 = new Date(this.SelectedRecord.tenderDate05);
        }
        if (this.SelectedRecord.updateDate) {
          this.SelectedRecord.updateDate = new Date(this.SelectedRecord.updateDate);
        }
        if (this.SelectedRecord.responseDate) {
          this.SelectedRecord.responseDate = new Date(this.SelectedRecord.responseDate);
        }

        await this.getListValueByDomain();
        this.getUserNameLong(this.SelectedRecord.domainId, this.bcp.getCurrentLoginUser());

        //Load data for Document tab
        this.inputDocumentCompany = this.SelectedRecord.companyCode;
        this.getDocumentData(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.projectId);

        //Load data for Log tab
        this.getLogDataByProject(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.projectId);

      });

  }


  //get record by id and assign to selected record
  getDataBySearchField() {
    if (this.loggedInType == 'D') {
      this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();
      this.SearchFieldHolder["dataRole"] = this.bcp.getCurrentDataRole();
      //this.SearchFieldHolder["companyCode"] = this.loggedInCompanyCode;
      this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
      this.http.post(this.PrimaryApiPath + "q", this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            this.applyGlobalFilter();
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    } else if (this.loggedInType == 'E') {
      this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();
      this.SearchFieldHolder["dataRole"] = this.bcp.getCurrentDataRole();
      this.SearchFieldHolder["companyCode"] = this.loggedInCompanyCode;
      this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
      this.http.post(this.PrimaryApiPath + "q", this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            this.applyGlobalFilter();
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    } else {
      this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
      this.http.post(this.PrimaryApiPath + "q", this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            this.applyGlobalFilter();
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    };

  }



  getDocumentData(DomainId: string, CompanyCode: string, ProjectId: string) {
    //Get for Document tab
    this.http.get(this.DocumentApiPath + "GetListByProject/" + DomainId + "/" + CompanyCode + "/" + ProjectId, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DocumentRecordList = result;
        this.documentLineNumber = 0;
        if (this.DocumentRecordList.length > 0) {
          for (var i = 0; i < this.DocumentRecordList.length; i++) {
            if (this.DocumentRecordList[i].lineNumber > this.documentLineNumber) {
              this.documentLineNumber = this.DocumentRecordList[i].lineNumber;
            }
            this.DocumentRecordList[i].projectDocumentCategoryDesc = this.DocumentCategoryList.filter(l => l.value == this.DocumentRecordList[i].projectDocumentCategory).map(m => m.label).toString();
            this.DocumentRecordList[i].projectDocumentTypeDesc = this.DocumentTypeList.filter(l => l.value == this.DocumentRecordList[i].projectDocumentType).map(m => m.label).toString();
          }
        }
      });
  }




  getLogDataByProject(DomainId: string, CompanyCode: string, ProjectId: string) {
    this.http.get(this.LogApiPath + "GetByProject/" + DomainId + "/" + CompanyCode + "/" + ProjectId, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.LogRecordList = result;
        if (this.LogRecordList.length == 0) {
          this.addNewLogRow();
        }
      });

  }


  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.RecordList);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "primengTable");
    });
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }



  findRecord() {
    this.RecordList = null;
    this.getDataBySearchField();
  }


  resetSearchField() {
    //dummy field, not use for searching
    this.SearchFieldHolder = JSON.parse('{"id": 0}');

    //set default value for all search fields
    //available field, please refer to the last part of [TableName]Controller.cs
    this.SearchFieldHolder["domainId"] = "";
    this.SearchFieldHolder["companyCode"] = "";
    this.SearchFieldHolder["projectId"] = "";

  }


  clearGlobalFilter() {
    this.globalFilterValue1 = "";
    this.globalFilterValue2 = "";
    this.globalFilterValue3 = "";
  }


  clearDocFilter() {
    this.globalFilterValue4 = "";
    this.globalFilterValue5 = "";
    this.globalFilterValue6 = "";
    
  }


  applyGlobalFilter() {
    var element = document.getElementById('globalFilter1');
    var event = new Event('input');

    element = document.getElementById('globalFilter1');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter2');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter3');
    element.dispatchEvent(event);
  }


  applyDocFilter() {
    var element = document.getElementById('globalFilter4');
    var event = new Event('input');

    element = document.getElementById('globalFilter4');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter5');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter6');
    element.dispatchEvent(event);
    
  }


  //-----------------------------------------------------------------------------
  //                      Add/Edit/Save/Delete Records
  //-----------------------------------------------------------------------------


  async editRecord(recordId, domainId, companyCode, projectId) {
    this.clearAllMessage();

    this.SelectedRecord = null;
    this.SelectedDocumentRecord = null;
    //this.SelectedMessageRecord = null;
    this.RecordList = null;
    this.DocumentRecordList = null;

    this.getDataById(recordId);
    this.getAttachmentList(recordId);

    this.FormTitle = "Project Submission";// - ID = " + recordId;
    this.ShowNotAuthorizedForm = false;
    this.ShowEditForm = true;
    this.AddMode = "N";

  }


  async saveRecord() {

    this.InputErrorMsg = [];

    //convert check box field value from boolean to character
    this.SelectedRecord.successAward = this.bcp.convertBooleanToYesNo(this.SelectedRecord.successAward);

    this.SelectedRecord.updateDate = this.bcp.getCurrentDateTime();
    this.SelectedRecord.updateUser = this.bcp.getCurrentLoginUser();

    if (this.SelectedRecord.tenderDate01) {
      this.SelectedRecord.tenderDate01 = this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate01);
    }
    if (this.SelectedRecord.tenderDate02) {
      this.SelectedRecord.tenderDate02 = this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate02);
    }
    if (this.SelectedRecord.tenderDate03) {
      this.SelectedRecord.tenderDate03 = this.bcp.convertCalendarDateTimeToJson(this.SelectedRecord.tenderDate03);
    }
    if (this.SelectedRecord.tenderDate04) {
      this.SelectedRecord.tenderDate04 = this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate04);
    }
    this.stringifyValue = JSON.stringify(this.SelectedRecord);
    //alert(this.stringifyValue);
    if (this.SelectedRecord.id == 0) {
      await this.http.post(this.PrimaryApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .toPromise();
    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      await this.http.put(this.PrimaryApiPath + "" + this.SelectedRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .toPromise();
    }
    //re-convert into calendar date for display
    this.SelectedRecord.responseDate = new Date(this.SelectedRecord.responseDate);
  }


  async createDocumentRecord(CompanyCode: string) {
    //initialize the SelectedDocumentRecord as a new record, and assign default value as required
    this.SelectedDocumentRecord = null;
    this.SelectedDocumentRecord = JSON.parse('{"id": 0}');
    this.SelectedDocumentRecord.domainId = this.SelectedRecord.domainId;
    this.SelectedDocumentRecord.companyCode = CompanyCode;
    this.SelectedDocumentRecord.projectId = this.SelectedRecord.projectId;
    this.documentLineNumber = this.documentLineNumber + 1;
    this.SelectedDocumentRecord.lineNumber = this.documentLineNumber;
    this.SelectedDocumentRecord.projectDocumentCategory = this.inputDocumentCategory;
    this.SelectedDocumentRecord.projectDocumentType = this.inputDocumentType;
    this.SelectedDocumentRecord.remark = this.inputRemark;
    this.SelectedDocumentRecord.applicableFlag = "";
    this.SelectedDocumentRecord.documentNumber = "";
    this.SelectedDocumentRecord.documentReference = "";
    this.SelectedDocumentRecord.documentIssuedDate = "";
    this.SelectedDocumentRecord.documentExpiryDate = "";
    this.SelectedDocumentRecord.instructionText = "";
    this.SelectedDocumentRecord.displaySequence = "";
    this.SelectedDocumentRecord.controlFlag01 = "";
    this.SelectedDocumentRecord.controlFlag02 = "";
    this.SelectedDocumentRecord.controlFlag03 = "";
    this.SelectedDocumentRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedDocumentRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedDocumentRecord.uploadUser = this.bcp.getCurrentLoginUser();
    this.SelectedDocumentRecord.uploadDate = this.bcp.getCurrentDateTime();
    this.SelectedDocumentRecord.downloadUser = "";
    this.SelectedDocumentRecord.downloadDate = "";
    this.SelectedDocumentRecord.updateUser = this.bcp.getCurrentLoginUser();
    this.SelectedDocumentRecord.updateDate = this.bcp.getCurrentDateTime();
    this.stringifyValue = JSON.stringify(this.SelectedDocumentRecord);
    //alert(this.stringifyValue);
    let addResult = await this.http.post(this.DocumentApiPath, this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any) => response).toPromise();
    this.SelectedDocumentRecord.id = addResult.id;

  }


  saveDocumentRecord() {
    this.stringifyValue = JSON.stringify(this.SelectedDocumentRecord);
    //console.log(this.stringifyValue);
    if (this.SelectedDocumentRecord.id == 0) {
      this.http.post(this.DocumentApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.DocumentApiPath + "" + this.SelectedDocumentRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            // Do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  //not used
  deleteRecord(pId) {
    if (window.confirm('Do you confirm to delete the selected record  ?')) {
      this.http.delete(this.PrimaryApiPath + pId, this.bcp.getHttpOptions())
        .subscribe(
          (data: any) => {
            this.findRecord();
          });
    }
  }



  deleteTender(pId) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete the selected tender ?',
      accept: () => {
        this.http.delete(this.PrimaryApiPath + "DeleteTender/" + pId, this.bcp.getHttpOptions())
          .subscribe(
            (data: any) => {
              this.findRecord();
            });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  close() {
    this.findRecord();
    this.SelectedRecord = null;
    this.SelectedDocumentRecord = null;
    this.inputDocumentCategory = null;
    this.inputDocumentType = null;
    this.inputRemark = null;
    this.RecordList = null;
    this.DocumentRecordList = null;
    this.documentLineNumber = 0;
    this.InputErrorMsg = [];

    this.ShowNotAuthorizedForm = false;
    this.ShowEditForm = false;
    this.FormTitle = "Work With Project";
    this.index = 0;

    this.clearAllMessage();
  }

  //-----------------------------------------------------------------------------
  //                                  Tab Table
  //-----------------------------------------------------------------------------



  addNewDocumentRow() {
    var blankRow: IProjectDoc;
    blankRow = null;
    blankRow = JSON.parse('{"id":0}');
    //incement line number by 1
    this.documentLineNumber = this.documentLineNumber + 1;
    blankRow.lineNumber = this.documentLineNumber;
    blankRow.documentNumber = "";
    blankRow.documentExpiryDate = "";
    blankRow.remark = "";
    blankRow.createUser = "";
    blankRow.createDate = "";
    blankRow.uploadUser = "";
    blankRow.uploadDate = "";
    blankRow.downloadUser = "";
    blankRow.downloadDate = "";
    //clone the whole array to a tmpArray and add new blank row
    const tmpArray = [...this.DocumentRecordList];
    tmpArray.push(blankRow);
    this.DocumentRecordList = tmpArray;

  }



  addNewLogRow() {
    var blankRow: IProjectLog;
    blankRow = null;
    blankRow = JSON.parse('{"id":0}');
    //clone the whole array to a tmpArray and add new blank row
    const tmpArray = [...this.LogRecordList];
    tmpArray.push(blankRow);
    this.LogRecordList = tmpArray;
  }


  processDocumentTable() {
    if (this.DocumentRecordList.length > 0) {
      this.DocumentRecordList.forEach(line => {
        if (line.lineNumber != 0) {
          //this.initDocumentRecord();
          this.SelectedDocumentRecord.id = line.id;
          this.SelectedDocumentRecord.domainId = this.SelectedRecord.domainId;
          this.SelectedDocumentRecord.companyCode = this.inputDocumentCompany;
          this.SelectedDocumentRecord.projectId = this.SelectedRecord.projectId;
          //this.SelectedDocumentRecord.tenderDocumentType = "PPSL";
          this.SelectedDocumentRecord.lineNumber = line.lineNumber;
         // this.SelectedDocumentRecord.tenderDocumentCategory = line.tenderDocumentCategory;
          //this.SelectedDocumentRecord.documentNumber = line.documentNumber;
          //this.SelectedDocumentRecord.documentExpiryDate = line.documentExpiryDate;
          this.SelectedDocumentRecord.remark = line.remark;
          //this.SelectedDocumentRecord.requestUploadFlag = line.requestUploadFlag;
          this.SelectedDocumentRecord.createUser = line.createUser;
          this.SelectedDocumentRecord.createDate = line.createDate;
          this.SelectedDocumentRecord.uploadUser = line.uploadUser;
          this.SelectedDocumentRecord.uploadDate = line.uploadDate;
          this.SelectedDocumentRecord.downloadUser = line.downloadUser;
          this.SelectedDocumentRecord.downloadDate = line.downloadDate;
          this.SelectedDocumentRecord.updateUser = this.bcp.getCurrentLoginUser();
          this.SelectedDocumentRecord.updateDate = this.bcp.getCurrentDateTime();
          this.saveDocumentRecord();
        }
      })
    }

  }



  //-----------------------------------------------------------------------------
  //                                  Attachment
  //-----------------------------------------------------------------------------

  //set file object for upload when file is selected
  selectUploadFile(event: any) {
    for (let file of event.files) {
      this.uploadFile = file;
    }
  }


  //upload the selected attachment for Document tab
  async processUploadFile(event, fileUpload) {

    this.SuccessUpload = false;
    //this.AttachmentAutoReload = false;

    if (this.uploadFile) {
      //initialize the SelectedDocumentRecord as a new record, and assign default value as required
      this.SelectedDocumentRecord = null;
      this.SelectedDocumentRecord = JSON.parse('{"id": 0}');
      this.SelectedDocumentRecord.domainId = this.SelectedRecord.domainId;
      this.SelectedDocumentRecord.companyCode = this.SelectedRecord.companyCode;
      this.SelectedDocumentRecord.projectId = this.SelectedRecord.projectId;
      this.documentLineNumber = this.documentLineNumber + 1;
      this.SelectedDocumentRecord.lineNumber = this.documentLineNumber;
      this.SelectedDocumentRecord.projectDocumentCategory = this.inputDocumentCategory;
      this.SelectedDocumentRecord.projectDocumentType = this.inputDocumentType;
      this.SelectedDocumentRecord.remark = this.inputRemark;
      this.SelectedDocumentRecord.applicableFlag = "";
      this.SelectedDocumentRecord.documentNumber = "";
      this.SelectedDocumentRecord.documentReference = "";
      this.SelectedDocumentRecord.documentIssuedDate = "";
      this.SelectedDocumentRecord.documentExpiryDate = "";
      this.SelectedDocumentRecord.instructionText = "";
      this.SelectedDocumentRecord.displaySequence = "";
      this.SelectedDocumentRecord.controlFlag01 = "";
      this.SelectedDocumentRecord.controlFlag02 = "";
      this.SelectedDocumentRecord.controlFlag03 = "";
      this.SelectedDocumentRecord.createUser = this.bcp.getCurrentLoginUser();
      this.SelectedDocumentRecord.createDate = this.bcp.getCurrentDateTime();
      this.SelectedDocumentRecord.uploadUser = this.bcp.getCurrentLoginUser();
      this.SelectedDocumentRecord.uploadDate = this.bcp.getCurrentDateTime();
      this.SelectedDocumentRecord.downloadUser = "";
      this.SelectedDocumentRecord.downloadDate = "";
      this.SelectedDocumentRecord.updateUser = this.bcp.getCurrentLoginUser();
      this.SelectedDocumentRecord.updateDate = this.bcp.getCurrentDateTime();
      this.stringifyValue = JSON.stringify(this.SelectedDocumentRecord);
      //alert(this.stringifyValue);
      let addResult = await this.http.post(this.DocumentApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .map((response: any) => response).toPromise();
      this.SelectedDocumentRecord.id = addResult.id;
      let sourceRecordId:any = addResult.id;

      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.SelectedRecord.domainId);
      formData.append("SourceTableName", "EtsProjectDoc");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();

      //save attachment record
      this.http.post(this.AttachmentApiPath + "UploadFile/" + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe((r : any) => {
          var result = JSON.parse(r);
          if (result.message == "succeed") {
            this.SuccessUpload = true;
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
            // write tender log
            if (this.SelectedRecord.id != 0) {
              this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
              this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
              this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
              this.WriteLogFieldHolder.projectLogCode = "10";
              this.WriteLogFieldHolder.projectDocumentCategory = this.inputDocumentCategory;
              this.WriteLogFieldHolder.projectDocumentType = this.inputDocumentType;
              this.WriteLogFieldHolder.remark = this.inputRemark;
              this.WriteLogFieldHolder.fileName = fileToUpload.name;
              this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
              this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
              this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
              this.http.post(this.LogApiPath + "WriteProjectLog/", this.stringifyValue, this.bcp.getHttpOptions())
                .subscribe((result: any[]) => {
                  //Load data for Log tab
                  this.getLogDataByProject(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.projectId);
                });
            }
            //reload table
            this.getDocumentData(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.projectId);
            //reset data fields
            this.inputDocumentCategory = "";
            this.inputDocumentType = "";
            this.inputRemark = "";
            fileUpload.clear();
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: result.message }];
          }
          
        });
    }

  }


  //download attachment by click on the filename
  downloadFile(recordID, projectDocumentCategory, projectDocumentType, remark, displayName) {
    //this.http.get(this.AttachmentApiPath + "File/" + recordID, { 'responseType': 'blob'} )
    this.http.get(this.AttachmentApiPath + "DownloadFile/" + recordID, this.bcp.getHttpOptionsAtt("blob"))
      .catch((err) => { return Observable.throw(err); })
      .subscribe((result: HttpResponse<Blob>) => {
        var returnFilename = this.bcp.getFilenameFromHttpResponse(result.headers.get('content-disposition'));

        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
          var blob = new Blob([result.body]);
          window.navigator.msSaveOrOpenBlob(blob, returnFilename);
        } else {
          var a = document.createElement("a");
          var blob = new Blob([result.body]);
          a.href = URL.createObjectURL(result.body);
          a.download = returnFilename;
          a.click();
        }
        // write project log
        if (this.SelectedRecord.id != 0) {
          this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
          this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
          this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
          this.WriteLogFieldHolder.projectLogCode = "50";
          this.WriteLogFieldHolder.projectDocumentCategory = projectDocumentCategory;
          this.WriteLogFieldHolder.projectDocumentType = projectDocumentType;
          this.WriteLogFieldHolder.remark = remark;
          this.WriteLogFieldHolder.fileName = displayName;
          this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
          this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
          this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
          this.http.post(this.LogApiPath + "WriteProjectLog/", this.stringifyValue, this.bcp.getHttpOptions())
            .subscribe((result: any[]) => {
              //Load data for Log tab
              this.getLogDataByProject(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.projectId);
            });
        }
      })
  }


  //Delete the attachment for Documents tab
  deleteAttachment(recordID, documentRecordID, projectDocumentCategory, projectDocumentType, remark, displayName) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete attachment?',
      accept: () => {
        this.http.delete(this.DocumentApiPath + documentRecordID, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.getDocumentData(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.projectId);
            if (recordID > 0) {
              this.http.delete(this.AttachmentApiPath + "DeleteFile/"+ recordID, this.bcp.getHttpOptions())
                .subscribe((result: any) => {
                  this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File deleted successfully' }];
                  // write tender log
                  if (this.SelectedRecord.id != 0) {
                    this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
                    this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
                    this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
                    this.WriteLogFieldHolder.projectLogCode = "40";
                    this.WriteLogFieldHolder.projectDocumentCategory = projectDocumentCategory;
                    this.WriteLogFieldHolder.projectDocumentType = projectDocumentType;
                    this.WriteLogFieldHolder.remark = remark;
                    this.WriteLogFieldHolder.fileName = displayName;
                    this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
                    this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
                    this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
                    this.http.post(this.LogApiPath + "WriteProjectLog/", this.stringifyValue, this.bcp.getHttpOptions())
                      .subscribe((result: any[]) => {
                        //Load data for Log tab
                        this.getLogDataByProject(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.projectId);
                      });
                  }
                });
            } else {
              //do nothing
            }
          });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Return to Inquiry Form for Save button
  saveThenFindRecord() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to save this record?',
      accept: () => {
        this.preProcessingAndSave();
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //get attachment list for Award tab
  getAttachmentList(recordID) {
    this.http.get(this.AttachmentApiPath + "List/" + this.bcp.getCurrentDomainId() + "/EtsTender/" + recordID, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.AttachmentList = result;
        this.AttachmentAutoReload = true;
      });
  }



  //sorting event trigger, default is sorting by id
  changeSort(event) {
    if (!event.order) {
      this.sortF = 'id';
    } else {
      this.sortF = event.field;
    }
  }

  //-----------------------------------------------------------------------------
  //                      Fetch List Data for Drop Down List
  //-----------------------------------------------------------------------------



  //-----------------------------------------------------------------------------
  //                            Report
  //-----------------------------------------------------------------------------

  async printProjectLog() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;
    let preDocumentCategory: string = "";
    let preDocumentType: string = "";
    let hLines = 12;

    this.listLength1 = 0;

    this.processingReport = "ProjectLog";
    this.processingFlag = "Y";
    //get the tender log data
    this.ReportFieldHolder = null;
    this.ReportFieldHolder = JSON.parse('{"id": 0}');
    this.ReportFieldHolder.domainId = this.SelectedRecord.domainId;
    this.ReportFieldHolder.tenderId = this.SelectedRecord.projectId;
    this.ReportFieldHolder.dataType = "L";
    this.stringifyValue = JSON.stringify(this.ReportFieldHolder);
    let reportList = await this.http.post(this.ReportApiPath + "Rpt_ProjectLog", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength1 = reportList.length;
    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "DocumentActivity");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Project Submission Activity Report";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Project Id: , " + this.ReportFieldHolder["tenderId"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    for (var i = 0; i < reportList.length; i++) {
      //write heading lines
      if (i == 0) {
        this.strLine = "Subject: , " + reportList[i].subject;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Contractor: , " + reportList[i].fullName + " [" + reportList[i].companyCode + "]";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Business Unit: , " + reportList[i].businessUnit;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Status: , " + reportList[i].tenderStatus;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = " ";
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        //write log header line
        this.strLine = "";
        this.strLine = "Category, Document Type, File Name, Remark, User, Date Time, Action";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      }
      //write company code line
      tmpStr = "";
      if (reportList[i].projectLogCode == "10") {
        tmpStr = "Uploaded";
      } else if (reportList[i].projectLogCode == "40") {
        tmpStr = "Removed";
      } else if (reportList[i].projectLogCode == "50") {
        tmpStr = "Downloaded";
      }
      this.strLine = "";
      this.strLine = this.strLine + reportList[i].documentCategoryName
        + this.delimiter + reportList[i].documentTypeName
        + this.delimiter + reportList[i].fileName
        + this.delimiter + reportList[i].remark
        + this.delimiter + reportList[i].createUserName
        + this.delimiter + this.bcp.formatDateToDisplayString(reportList[i].createDate, true, true, '-', ':')
        + this.delimiter + tmpStr;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      if (reportList[i].projectDocumentCategory == preDocumentCategory && reportList[i].projectDocumentType == preDocumentType) {
        delete (worksheet["A" + (hLines + 1 + i)]);
        delete (worksheet["B" + (hLines + 1 + i)]);
      }
      preDocumentCategory = reportList[i].projectDocumentCategory;
      preDocumentType = reportList[i].projectDocumentType;
    }
    //total section
    //this.strLine = " ";
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //this.strLine = "No. of Lines: ," + detailList.length;
    //this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //worksheet["C"+11].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    this.fixWidth(worksheet);
    this.applyCellFormat(worksheet);

    XLSX.writeFile(workbook, "Report_DocumentActivity.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  updateExcelRow() {
    const colIndexArray = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    let dataArray: string[];
    this.excelRow = [];
    this.strLine = this.strLine.replace(/undefined/gi, "");
    this.strLine = this.strLine.replace(/Null/gi, "");
    this.strLine = this.strLine.replace(/null/gi, "");
    dataArray = this.strLine.split(this.delimiter);
    for (let index = 0; index < dataArray.length; index += 1) {
      this.excelRow[index] = dataArray[index];
    }
  }


  charToColIndex(colName) {
    let result = 0;
    if (colName.length == 1) {
      result = colName.charCodeAt(0) - 64
    } else {
      result = (colName[0].charCodeAt(0) - 64) * 26;
      result = result + colName[1].charCodeAt(0) - 64;
    }
    return result;
  }


  addRangeToCellList(startCol, startRow, endCol, endRow, appendFlag) {
    let startColIndex = this.charToColIndex(startCol);
    let endColIndex = this.charToColIndex(endCol);
    let currCell: string;
    if (!appendFlag || this.cellList == null || this.cellList == undefined) {
      this.cellList = [];
    }

    for (let c = startColIndex; c <= endColIndex; c++) {
      for (let r = startRow; r <= endRow; r++) {
        this.cellList.push(this.colIndexToChar(c) + r);
      }

    }
  }


  fixWidth(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 30 }, { width: 30 }, { width: 50 }, { width: 50 }, { width: 25 }, //ABCDE
      { width: 25 }, { width: 15 }, { width: 25 }, { width: 25 }, { width: 25 }, //FGHIJ
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //KLMNO
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }


  applyCellFormat(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];
    let hLines = 12;

    //bold
    //first column until heading title
    this.addRangeToCellList("A", 2, "A", hLines, true);
    //tender id line
    this.addRangeToCellList("A", 4, "B", 4, true);
    //log heading line
    this.addRangeToCellList("A", hLines, "G", hLines, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.cellList = [];
    this.addRangeToCellList("A", 4, "B", 4, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    this.cellList = [];
    //tender Id
    this.addRangeToCellList("A", 4, "B", 4, true);
    //log title
    this.addRangeToCellList("A", hLines, "G", hLines, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //wraptext
    this.cellList = [];
    //this.addRangeToCellList("C", 14, "C", 14, true);
    //this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    //worksheet["C13"].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //amount with 2dp
    //aware if any space before the cell value
    //tmpList = ["D11"];
    this.cellList = [];
    //this.addRangeToCellList("E", 11, "S", this.lastRowNumber, true);
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };

  formatCell(worksheet: XLSX.WorkSheet, localCellList: string[]
    , formatRule: string) {

    let defaultStyle = {
      font: {
        bold: false,
        italic: false,
        underline: false
      },
      border: {
        top: { style: "none", color: { auto: 1 } },
        right: { style: "none", color: { auto: 1 } },
        bottom: { style: "none", color: { auto: 1 } },
        left: { style: "none", color: { auto: 1 } }
      },
      alignment: {
        wrapText: false
      }
    };

    let newStyle = JSON.parse(JSON.stringify(defaultStyle));
    let originalStyle = JSON.parse(JSON.stringify(defaultStyle));

    const fontSetting01 = {
      bold: true,
      italic: false,
      underline: false
    };

    const fontSetting02 = {
      bold: true,
      italic: false,
      underline: true
    };

    const borderSetting01 = {
      top: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } }
    };

    const bgcolorSetting01 = {
      patternType: "solid",
      //fgColor: { rgb: "e6f7eb" }
      fgColor: { rgb: "f7f372" }
    }

    for (let i = 0; i < localCellList.length; i++) {
      //cache the original style of the cell

      if (worksheet[localCellList[i]] !== undefined) {
        if (formatRule === "BOLD" || formatRule === "BORDER"
          || formatRule === "BGCOLOR_01" || formatRule === "WRAPTEXT"
          || formatRule === "BOLDUNDERLINE") {
          newStyle = JSON.parse(JSON.stringify(defaultStyle));
          originalStyle = JSON.parse(JSON.stringify(defaultStyle));
          if (worksheet[localCellList[i]].s !== undefined) {
            originalStyle = JSON.parse(JSON.stringify(worksheet[localCellList[i]].s));
          }

          if (originalStyle.font !== undefined) {
            newStyle.font = originalStyle.font;
          }
          if (originalStyle.border !== undefined) {
            newStyle.border = originalStyle.border;
          }
          if (originalStyle.fill !== undefined) {
            newStyle.fill = originalStyle.fill;
          }

          if (formatRule === "BOLD") {
            newStyle.font = fontSetting01;
          }

          if (formatRule === "BOLDUNDERLINE") {
            newStyle.font = fontSetting02;
          }

          if (formatRule === "BORDER") {
            newStyle.border = borderSetting01;
          }

          if (formatRule === "BGCOLOR_01") {
            newStyle.fill = bgcolorSetting01;
          }

          if (formatRule === "WRAPTEXT") {
            newStyle.alignment = { wrapText: true };
          }

          worksheet[localCellList[i]].s = newStyle;
        }

        if (formatRule === "AMOUNT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "_($* #,##0.00_);_($* (#,##0.00);_($* -??_);_(@_)";
        }

        if (formatRule === "NUMBER") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00";
        }

        if (formatRule === "NUMBER_4DP") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.0000";
        }

        if (formatRule === "PERCENT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00%";
        }
      } else {
        //console.log("Error when Formatting Cell " + localCellList[i]);
      }
    }



  }//formatCell end

  colIndexToChar(colIndex) {
    let result: string = "";
    let adjustFlag = (colIndex - (Math.floor(colIndex / 26) * 26)) === 0 ? 1 : 0; // for AZ/BZ ... handling

    if (colIndex <= 26) {
      result = String.fromCharCode(colIndex + 64);
    } else {
      result = String.fromCharCode(Math.floor((colIndex - adjustFlag) / 26) + 64); //assume max column is ZZ
      result = result + String.fromCharCode(colIndex - (Math.floor((colIndex - adjustFlag) / 26) * 26) + 64);
    }
    return result;
  }

  //-----------------------------------------------------------------------------
  //                      Checking/ Other Actions
  //-----------------------------------------------------------------------------

  clearAllMessage() {
    this.InputErrorMsg = [];
    this.resultMsgs = [];

  }


  clearAwardCompanyCode() {
    this.SelectedRecord.awardCompanyCode = "";

  }


  async preProcessingAndSave() {
    //clear existing messages
    this.clearAllMessage();
    this.checkedError = 'N';
    //check domain
    if (this.SelectedRecord.domainId.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Domain is missing   ' });
    };
    //check subject
    if (this.SelectedRecord.subject.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Subject is missing   ' });
    };
    //check tender category
    if (this.SelectedRecord.tenderCategory.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Tender Category is missing   ' });
    };
    //check tender property
    if (this.SelectedRecord.tenderProperty.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Tender Property is missing   ' });
    };
    //check business unit
    if (this.SelectedRecord.businessUnit.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Business Unit is missing   ' });
    };
    //check contact person
    if (this.SelectedRecord.fullName.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Contact Person is missing   ' });
    };
    //check tender summary
    if (this.SelectedRecord.tenderSummary.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Summary must have content   ' });
    };
    //check open date
    if (this.SelectedRecord.tenderDate02 == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Open Date is missing   ' });
    };
    //check due date
    if (this.SelectedRecord.tenderDate03 == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Due Date is missing   ' });
    };


    //check unique if above checking passed
    if (this.checkedError == 'N') {
      let tmpApiString1: string = "";
      tmpApiString1 = JSON.stringify(this.SelectedRecord);
      let checkResult1 = await this.http.post(this.PrimaryApiPath + "ValidateKeyFields/", tmpApiString1, this.bcp.getHttpOptions())
        .map((response: any) => JSON.parse(response.toString())).toPromise();
      if (checkResult1.validFlag == "N") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Tender Id is duplicated   ' });
      }
    };

    //save record finally if no error
    if (this.checkedError == 'N') {
      //Save and Get Tender Record ID
      await this.saveRecord();
      this.newTenderRecordId = await this.http.get(this.PrimaryApiPath + "GetID/" + this.SelectedRecord.domainId + "/" + this.SelectedRecord.companyCode + "/" + this.SelectedRecord.projectId, this.bcp.getHttpOptions()).toPromise();
      //process tag table
      if (this.ShowEditForm) {
        this.processDocumentTable();
      };
      //control process flow
      this.ShowNotAuthorizedForm = false;
      this.ShowEditForm = false;
      this.FormTitle = "Work With Tender Process";
      this.findRecord();
    };

  }



//ending of export class
}


interface IProject {
  id?;
  domainId?;
  companyCode?;
  projectId?;
  subject?;
  tenderCategory?;
  tenderProperty?;
  businessUnit?;
  estimatedBudget?;
  fullName?;
  fullNameOther?;
  phoneArea?;
  phone?;
  email?;
  tenderStatus?;
  tenderSummary?;
  tenderDate01?;
  tenderDate02?;
  tenderDate03?;
  tenderDate04?;
  tenderDate05?;
  tenderDate06?;
  tenderDate07?;
  tenderDate08?;
  tenderDate09?;
  tenderDate10?;
  tenderDate11?;
  tenderDate12?;
  purchaseNumber?;
  priceValidityMonths?;
  priceValidityDate?;
  retentionPercent?;
  liquidatedDamages?;
  defectsLiabilityPeriod?;
  approveUser?;
  approveDate?;
  tenderResponseStatus?;
  expressInterest?;
  expressUser?;
  expressDate?;
  tenderResponseType?;
  tenderRevisionType?;
  remark?;
  title?;
  contractSum?;
  includeOptionalFlag?;
  adjustedContractSum?;
  adjustmentRemark?;
  withdrawFlag?;
  withdrawUser?;
  withdrawDate?;
  controlFlag01?;
  controlFlag02?;
  controlFlag03?;
  responseUser?;
  responseDate?;
  acceptAward?;
  reason?;
  acceptUser?;
  acceptDate?;
  successAward?;
  awardCompanyCode?;
  awardComment?;
  createUser?;
  createDate?;
  updateUser?;
  updateDate?;
}


interface IProjectDoc {
  id?;
  domainId?;
  companyCode?;
  projectId?;
  lineNumber?;
  projectDocumentCategory?;
  projectDocumentType?;
  remark?;
  applicableFlag?;
  documentNumber?;
  documentReference?;
  documentIssuedDate?;
  documentExpiryDate?;
  instructionText?;
  displaySequence?;
  controlFlag01?;
  controlFlag02?;
  controlFlag03?;
  createUser?;
  createDate?;
  uploadUser?;
  uploadDate?;
  downloadUser?;
  downloadDate?;
  updateUser?;
  updateDate?;
  // not database field
  actualFileName?;
  displayName?;
  attachmentRecordId?;
  projectDocumentCategoryDesc?;
  projectDocumentTypeDesc?;
}


interface IProjectLog {
  id?;
  domainId?;
  companyCode?;
  projectId?;
  createDate?;
  createUser?;
  projectLogCode?;
  projectDocumentCategory?;
  projectDocumentType?;
  description?;
  remark?;
  fileName?;
  projectRecordId?;
}


interface IUpdateTender {
  domainId?;
  tenderId?;
}

interface IWriteLog {
  recordId?;
  domainId?;
  projectLogCode?;
  projectDocumentCategory?;
  projectDocumentType?;
  remark?;
  fileName?;
  createUser?;
  createDate?;
}


interface IDataRole {
}

interface IProcessRole {
}

interface IListValue {
  label?;
  value?;
}

interface IAttachmentValue {
  filePath?;
  id?;
  domainId?;
  sourceTable?;
  sourceRecordId?;
  actualFileName?;
  displayName?;
  createDate?;
  updateUser?;
  updateDate?;
}

interface SelectItem {
}

interface Message {
}


interface IGenNextNumber {
  domainId?;
  tableKey?;
  year?;
  inputDate?;
  updateUser?;
  updateDate?;
}


interface INextNumber {
  nextNumber?;
  nextKey?;
}

interface IUserName {
  userName?;
  userNameOther?;
  userNameLong?;
  userEmail?;
}

interface IReportData {
  domainId?;
  tenderId?;
  companyCode?;
  dataType?;
}

interface ICompanyStatus {
  vertificationKey?;
  registerFlag?;
  inviteFlag?;
  tempCompany?;
  companyStatus?;
}
